import { ref } from "vue";
import { defineStore } from "pinia";

import { COUNTRY_DATA_TTL } from "@/constants";

import { fetchCountryData } from "@/api/repositories/data";

export const useCountryStore = defineStore(
  "country",
  () => {
    const countryData = ref(undefined);
    const fetchedCountryDataTimestamp = ref(0);

    const setCountryData = (data) => {
      countryData.value = data;
    };

    const getCountryData = async () => {
      if (Date.now() - fetchedCountryDataTimestamp.value < COUNTRY_DATA_TTL) {
        return;
      }

      const data = await fetchCountryData();
      setCountryData(data);
      fetchedCountryDataTimestamp.value = Date.now();
    };

    const resetCountryData = () => {
      setCountryData(undefined);
      fetchedCountryDataTimestamp.value = 0;
    }

    return {
      countryData,
      fetchedCountryDataTimestamp,
      getCountryData,
      setCountryData,
      resetCountryData
    };
  },
  { persist: true }
);
